import { z } from 'zod';
import { IdSchema, TimestampSchema, PaginationSchema, PageSchema } from './common.js';

/** 资源种类（对应资源库的三个分段 Tab） */
export const AssetKindSchema = z.enum(['video', 'image', 'group']);
export type AssetKind = z.infer<typeof AssetKindSchema>;

/** 资源条目 */
export const AssetSchema = z.object({
  id: IdSchema,
  kind: AssetKindSchema,
  name: z.string(),
  /** TOS object key（不含 bucket） */
  objectKey: z.string(),
  /** 字节数 */
  sizeBytes: z.number().int().nonnegative(),
  /** 人类可读大小，如 "18.4 MB" */
  sizeText: z.string(),
  createdAt: TimestampSchema,
  /** group 类型才有：成员数量 */
  itemCount: z.number().int().optional(),
  /** 视频/图片才有：预览 URL（presigned） */
  previewUrl: z.string().url().optional(),
});
export type Asset = z.infer<typeof AssetSchema>;

/** 列表请求 */
export const ListAssetsRequestSchema = z.object({
  kind: AssetKindSchema,
  search: z.string().optional(),
}).merge(PaginationSchema);
export type ListAssetsRequest = z.infer<typeof ListAssetsRequestSchema>;

export const ListAssetsResponseSchema = PageSchema(AssetSchema);
export type ListAssetsResponse = z.infer<typeof ListAssetsResponseSchema>;

/** 申请上传 URL（presigned PUT） */
export const RequestUploadUrlRequestSchema = z.object({
  kind: AssetKindSchema,
  fileName: z.string(),
  contentType: z.string(),
});
export type RequestUploadUrlRequest = z.infer<typeof RequestUploadUrlRequestSchema>;

export const RequestUploadUrlResponseSchema = z.object({
  uploadUrl: z.string().url(),
  objectKey: z.string(),
  /** 上传成功后客户端用这个 id 调 confirm 落库 */
  assetId: IdSchema,
  expiresAt: TimestampSchema,
});
export type RequestUploadUrlResponse = z.infer<typeof RequestUploadUrlResponseSchema>;

/** 上传完成后通知 BFF 落库。
 * sizeBytes 可选——real 模式下 BFF 会从 TOS HEAD 拿到权威值；mock 模式下用客户端 file.size 直接落库。
 */
export const ConfirmUploadRequestSchema = z.object({
  assetId: IdSchema,
  sizeBytes: z.number().int().nonnegative().optional(),
});
export type ConfirmUploadRequest = z.infer<typeof ConfirmUploadRequestSchema>;

export const ConfirmUploadResponseSchema = AssetSchema;
export type ConfirmUploadResponse = z.infer<typeof ConfirmUploadResponseSchema>;
